import React, {useContext, useEffect, useRef, useState} from "react"
import Row from "@amzn/meridian/row"
import Column from "@amzn/meridian/column"
import {TableCell, TableRow} from "@amzn/meridian/table";
import { injectIntl} from "react-intl";
import {
    chainWalk,
    getAssetRefreshInterval,
    sortComparator,
    compressAutoLoaderConfig,getTestConfigKey,
} from "../../util/Util";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import arrowRightTokens from "@amzn/meridian-tokens/base/icon/arrow-right-large";
import Loader from "../../loader/Loader";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import plusCircleTokens from "@amzn/meridian-tokens/base/icon/plus-circle";
import uploadTokens from "@amzn/meridian-tokens/base/icon/upload-small";
import UploadFileModal from "../../commonui/UploadFileModal";
import {AutoLoaderConfigCSVParser, AutoLoaderTestConfigCSVParser} from "../../util/Parsers";
import {ASCENDING, CONFIG_TYPE, OPERATION_COLOR, SEARCH_ROW_COLOR} from "../../util/Constants";
import {DraftContext} from "../../draftSave/context/DraftSaveContext";
import ConfigurationTabHeader from "../../commonui/ConfigurationTabHeader";
import PaginatedTable from "../../commonui/PaginatedTable";
import Text from "@amzn/meridian/text";
import {getAssetVersions, getAssetByVersion} from "../../resources/AssetResource";
import RollbackModal from "../../rollback/RollbackModal";
import {GlobalStateContext} from "../../global/context/GlobalStateContext";
import {getLocalizedMessage} from "../../util/Localization";
import {AutoLoaderDeviceOverviewContext} from "./context/AutoLoaderDeviceOverviewContext";
import DeleteAutoLoaderConfigurationModal from "./modal/DeleteAutoLoaderConfigurationModal";
import AddAutoLoaderConfigurationModal from "./modal/AddAutoLoaderConfigurationModal";
import Input from "@amzn/meridian/input";
import DeleteAutoLoaderTestPackageModal from "./modal/DeleteAutoLoaderTestPackageModal";
import AddAutoLoaderTestPackageModal from "./modal/AddAutoLoaderTestPackageModal";

const AutoLoaderDeviceConfiguration = ({intl}) => {

    const {viewModel, dispatch} = useContext(AutoLoaderDeviceOverviewContext);
    const {getDraftData, setDraftData, resetDraftData, getFilteredDraftData, isDataEdited} = useContext(DraftContext);
    const [openAddModal, setOpenAddModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openCSVModal, setOpenCSVModal] = useState(false)
    const [valueConfiguration, setValueConfiguration] = useState("")
    const [selectedMac, setSelectedMac] = useState("")
    const [showRollbackModal, setShowRollbackModal] = useState(false)
    const [isVersionsLoading, setIsVersionsLoading] = useState(false);
    const [selectedVersion, setSelectedVersion] = useState("");
    const [rollBackVersions, setRollbackVersions] = useState([]);
    const [autoLoaderTestPackageSortColumn, setAutoLoaderTestPackageSortColumn] = useState("scannables");
    const [autoLoaderTestPackageSortOrder, setAutoLoaderTestPackageSortOrder] = useState(ASCENDING);
    const [autoLoaderDestinationColumn, setAutoLoaderDestinationColumn] = useState("destination");
    const [autoLoaderConfigSortOrder, setAutoLoaderConfigSortOrder] = useState(ASCENDING);
    const [scannablesSearchInput, setScannablesSearchInput] = useState('');
    const [sortZoneSearchInput, setSortZoneSearchInput] = useState('');
    const tableEndRef = useRef(null);
    const {showCustomAlert} = useContext(GlobalStateContext);

    const PAGE_CONFIGURATION_KEYS = [CONFIG_TYPE.AUTOLOADER_DESTINATION, CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE]

    const searchDataForTestConfigTable = () => {
        let data = getDraftData({
            stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
            subKey: selectedMac
        });

        data = data.filter(item => getTestConfigKey(item.scannables)
            .toLowerCase()
            .includes(scannablesSearchInput.toLowerCase()))
            .filter(item => item.sortZone
                .toLowerCase()
                .includes(sortZoneSearchInput.toLowerCase())
            )
        data = data.sort((a, b) =>
            autoLoaderTestConfigColumns[autoLoaderTestPackageSortColumn](a, b, autoLoaderTestPackageSortOrder === ASCENDING)
        )
        return data;
    };

    const getModalContent = async () => {
        setIsVersionsLoading(true);
        let versionsData = await getAssetVersions(selectedMac);
        setRollbackVersions(versionsData.data.assetVersionDetailsList);
        setIsVersionsLoading(false);
    }

    const loadRollbackDataToDraft = async () => {
        let rollbackData = await getAssetByVersion(selectedMac, selectedVersion);
        const testPackageData = chainWalk(() => JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.autoLoaderTestPackage), []);
        const autoLoaderConfigData = chainWalk(() => JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.autoLoaderConfig), []);
        if (testPackageData.length) {
            setDraftData({
                data: testPackageData,
                stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
                subKey: selectedMac,
                allRowsAdded: true,
                override: true
            });
        }
        if (autoLoaderConfigData.length) {
            setDraftData({
                data: autoLoaderConfigData,
                stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
                subKey: selectedMac,
                allRowsAdded: true,
                override: true
            });
        }
    }

    useEffect(() => {
        if (!openAddModal && !openDeleteModal) {
            getData()
            const interval = setInterval(() => {
                if (!document.hidden) {
                    getData();
                }
            }, getAssetRefreshInterval());
            return () => clearInterval(interval);
        }
    }, [openAddModal, openDeleteModal]);

    useEffect(() => {
        setDraftData({
            data: chainWalk(() => viewModel.autoLoaderTestPackage[selectedMac], []),
            stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
            subKey: selectedMac,
        });
        setDraftData({
            data: chainWalk(() => viewModel.autoLoaderConfig[selectedMac], []),
            stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
            subKey: selectedMac,
        })
    }, [selectedMac]);

    const getAutoLoaderDeviceList = () => {
        const autoLoaderDeviceList = Object.values(viewModel.autoLoaderDeviceInformation);
        autoLoaderDeviceList && autoLoaderDeviceList.sort((a, b) => {
            if (a.name < b.name) {
                return -1
            } else if (b.name > a.name) {
                return 1
            }
            return 0
        })
        return autoLoaderDeviceList
    }

    const getData = () => {
        if(isDataEdited(PAGE_CONFIGURATION_KEYS)) return;
        setOpenAddModal(false)
        setOpenDeleteModal(false)
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
    const scrollToBottom = () => {
        tableEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    const updateDestinationConfigDraftData = (autoLoaderConfig) => {
        const compressedAutoLoaderConfig = compressAutoLoaderConfig(autoLoaderConfig);
        setDraftData({
            data: chainWalk(() => compressedAutoLoaderConfig, []),
            stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
            subKey: selectedMac,
            allRowsAdded: true,
            override: true
        })
    }

    const updateTestConfigDraftData = (testPackage) => {
        setDraftData({
            data: chainWalk(() => testPackage, []),
            stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
            subKey: selectedMac,
            allRowsAdded: true,
            override: true
        })
    }

    const deployDraftAutoLoaderAsset = () => {
        const autoLoaderDestinationList = getFilteredDraftData({
            stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
            subKey: selectedMac
        });
        const testPackageList = getFilteredDraftData({
            stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
            subKey: selectedMac
        });

        dispatch({
            type: 'UPDATE_AUTOLOADER_CONFIGURATION',
            data: {
                dispatcher: dispatch,
                showCustomAlert: showCustomAlert,
                configurations: {
                    autoLoaderConfig: autoLoaderDestinationList,
                    autoLoaderTestPackage: testPackageList,
                },
                mac: selectedMac
            }
        });

        setDraftData({
            data: autoLoaderDestinationList,
            stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
            subKey: selectedMac,
            override: true
        })

        setDraftData({
            data: testPackageList,
            stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
            subKey: selectedMac,
            override: true
        })
    }

    function onClickUploadCSV() {
        setOpenCSVModal(true)
    }

    function onClickAddSingle() {
        setOpenAddModal(true)
    }

    function onClickDeleteConfiguration() {
        setOpenDeleteModal(true)
    }

    const getDataStringFromConfig = (config) => {
        return chainWalk(() => config.installation.locations.join(' '))
    }

    const renderAutoLoaderConfigTableRow = (config, index) => {
        const dataString = getDataStringFromConfig(config)
        const prevDataString = chainWalk(() => getDataStringFromConfig(config.prev), null)
        return (
            <TableRow highlightOnHover={true} key={index} backgroundColor={OPERATION_COLOR[config.operation]}>
                <TableCell alignmentVertical="top">
                    <Column spacingInset="200 none none">{config.destination}</Column>
                </TableCell>
                <TableCell>
                    {config.installation.type}
                </TableCell>
                <TableCell>
                    <Row>
                        {prevDataString && <Text> {prevDataString} </Text>}
                        {prevDataString && <Icon tokens={arrowRightTokens}/>}
                        <Text> {dataString} </Text>
                    </Row>
                </TableCell>
            </TableRow>
        )
    }

    const autoLoaderDestinationConfigColumns = {
        destination: (a, b, ascending) => {
            return ascending ? sortComparator(a.destination, b.destination) : -sortComparator(a.destination, b.destination);
        },
        installationType: (a, b, ascending) => {
            return ascending ? sortComparator(a.installation.type, b.installation.type) : -sortComparator(a.installation.type, b.installation.type);
        },
        locations: (a, b, ascending) => {
            return ascending ? sortComparator(getDataStringFromConfig(a), getDataStringFromConfig(b)) : -sortComparator(getDataStringFromConfig(a), getDataStringFromConfig(b));
        }
    }

    const autoLoaderTestConfigColumns = {
        scannables: (a, b, ascending) => {
            let scannableFirst = Array.isArray(a.scannables) ? a.scannables.join(' ') : a.scannables;
            let scannableSecond = Array.isArray(b.scannables) ? b.scannables.join(' ') : b.scannables;
            return ascending ? sortComparator(scannableFirst, scannableSecond) : -sortComparator(scannableFirst, scannableSecond);
        },
        sortZone: (a, b, ascending) => {
            return ascending ? sortComparator(a.sortZone, b.sortZone) : -sortComparator(a.sortZone, b.sortZone);
        },
        length: (a, b, ascending) => {
            return ascending ? sortComparator(parseFloat(a.length), parseFloat(b.length))
                : -sortComparator(parseFloat(a.length), parseFloat(b.length));
        },
        height: (a, b, ascending) => {
            return ascending ? sortComparator(parseFloat(a.height), parseFloat(b.height))
                : -sortComparator(parseFloat(a.height), parseFloat(b.height));
        },
        width: (a, b, ascending) => {
            return ascending ? sortComparator(parseFloat(a.width), parseFloat(b.width))
                : -sortComparator(parseFloat(a.width), parseFloat(b.width));
        },
        weight: (a, b, ascending) => {
            return ascending ? sortComparator(parseFloat(a.weight), parseFloat(b.weight))
                : -sortComparator(parseFloat(a.weight), parseFloat(b.weight));
        }
    };

    const renderAutoLoaderConfigTableHeader = () => {
        return (<TableRow highlightOnHover={false}>
            <TableCell sortColumn="destination">
                {getLocalizedMessage({intl, stringId: "destination.id"})}
            </TableCell>
            <TableCell sortColumn="installationType">
                {getLocalizedMessage({intl, stringId: "destination.installationtype"})}
            </TableCell>
            <TableCell sortColumn="location">
                {getLocalizedMessage({intl, stringId: "destination.locations"})}
            </TableCell>
        </TableRow>)
    }

    const getHeaderProps = () => {
        return {
            selectedMac,
            setSelectedMac,
            valueConfiguration,
            setValueConfiguration,
            isAutoLoaderConfig: valueConfiguration === CONFIG_TYPE.AUTOLOADER_DESTINATION, intl,
            defaultSelection: "",
            resetDraftData,
            deployDraft: deployDraftAutoLoaderAsset,
            scrollToBottom,
            sortedDeviceList: getAutoLoaderDeviceList(),
            configurationKeys: PAGE_CONFIGURATION_KEYS,
            refreshDeps: [viewModel.timestamp],
            isDeployDisabled: !isDataEdited(PAGE_CONFIGURATION_KEYS),
            isRollbackDisabled: !selectedMac || isDataEdited(PAGE_CONFIGURATION_KEYS),
            rollbackClickHandler: () => {getModalContent(); setShowRollbackModal(true)}
        }
    }

    const renderTestConfigTableHeader = () => (
        <TableRow highlightOnHover={false}>
            <TableCell>
                {getLocalizedMessage({intl, stringId: "table.index"})}
            </TableCell>
            <TableCell sortColumn="scannables">
                {getLocalizedMessage({intl, stringId: "test.scannables"})}
            </TableCell>
            <TableCell sortColumn="length">
                {getLocalizedMessage({intl, stringId: "destination.length"})}
            </TableCell>
            <TableCell sortColumn="height">
                {getLocalizedMessage({intl, stringId: "destination.height"})}
            </TableCell>
            <TableCell sortColumn="width">
                {getLocalizedMessage({intl, stringId: "destination.width"})}
            </TableCell>
            <TableCell sortColumn="weight">
                {getLocalizedMessage({intl, stringId: "destination.weight"})}
            </TableCell>
            <TableCell sortColumn="sortZone">
                {getLocalizedMessage({intl, stringId: "bay.sortzone"})}
            </TableCell>
        </TableRow>
    );

    const renderTestConfigTableRow = (config, serialNumber) => (
        <TableRow highlightOnHover={true} backgroundColor={OPERATION_COLOR[config.operation]}>
            <TableCell>{serialNumber}</TableCell>
            <TableCell>
                {Array.isArray(config.scannables) ? config.scannables.join(' ') : config.scannables}
            </TableCell>
            <TableCell>{config.length}</TableCell>
            <TableCell>{config.height}</TableCell>
            <TableCell>{config.width}</TableCell>
            <TableCell>{config.weight}</TableCell>
            <TableCell>{config.sortZone}</TableCell>
        </TableRow>
    );

    const renderSearchRow = () => (
        <TableRow backgroundColor={SEARCH_ROW_COLOR}>
            <TableCell/>
            <TableCell>
                <Input
                    className="input-search-class"
                    value={scannablesSearchInput}
                    onChange={setScannablesSearchInput}
                    type="text"
                    placeholder="Search"
                    width="70%"
                    size="small"/>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>
                <Input
                    className="input-search-class"
                    value={sortZoneSearchInput}
                    onChange={setSortZoneSearchInput}
                    type="text"
                    placeholder="Search"
                    width="70%"
                    size="small"/>
            </TableCell>
        </TableRow>
    );

    if (viewModel.loadingOverview) {
        return (<Loader/>)
    } else {
        return (
            <Column>
                <ConfigurationTabHeader {...getHeaderProps()}/>
                <RollbackModal
                    showRollbackModal={showRollbackModal}
                    setShowRollbackModal={setShowRollbackModal}
                    isVersionsLoading={isVersionsLoading}
                    selectedVersion={selectedVersion}
                    setSelectedVersion={setSelectedVersion}
                    rollBackVersions={rollBackVersions}
                    loadRollbackDataToDraft={loadRollbackDataToDraft}
                    intl={intl}
                />
                {valueConfiguration === CONFIG_TYPE.AUTOLOADER_DESTINATION && selectedMac &&
                    <Column>
                        <PaginatedTable
                            data={getDraftData({stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION, subKey: selectedMac}).sort((a, b) => {
                                return autoLoaderDestinationConfigColumns[autoLoaderDestinationColumn](a, b, autoLoaderConfigSortOrder === ASCENDING);
                            })}
                            renderRow={renderAutoLoaderConfigTableRow}
                            renderHeader={renderAutoLoaderConfigTableHeader}
                            sortColumn={autoLoaderDestinationColumn}
                            sortDirection={autoLoaderConfigSortOrder}
                            onSort={({sortColumn, sortDirection}) => {
                                setAutoLoaderDestinationColumn(sortColumn);
                                setAutoLoaderConfigSortOrder(sortDirection);
                            }}
                        />
                        <Row width="100%" widths={["100", "100", "fill", "100"]}>

                                <Button onClick={onClickAddSingle} type="primary" size="small">
                                    <Icon tokens={plusCircleTokens}/>
                                    {getLocalizedMessage({intl, stringId: "autoloaderconfig.addupdate"})}
                                </Button>

                                <Button onClick={onClickUploadCSV} type="primary" size="small">
                                    <Icon tokens={uploadTokens}/>
                                    {getLocalizedMessage({intl, stringId: "autoloaderconfig.uploadCSV"})}
                                </Button>

                            <Box></Box>

                                <Button onClick={onClickDeleteConfiguration} size="small" type="tertiary">
                                    <Icon tokens={trashTokens}/>
                                    {getLocalizedMessage({intl, stringId: "config.delete"})}
                                </Button>
                        </Row>
                        <UploadFileModal mac={selectedMac}
                                         open={openCSVModal} setOpen={setOpenCSVModal}
                                         parser={AutoLoaderConfigCSVParser} updateConfig={updateDestinationConfigDraftData}/>
                        <AddAutoLoaderConfigurationModal mac={selectedMac}
                                                         open={openAddModal} setOpen={setOpenAddModal}/>
                        <DeleteAutoLoaderConfigurationModal mac={selectedMac}
                                                            open={openDeleteModal} setOpen={setOpenDeleteModal}/>
                        <div ref={tableEndRef}/>
                    </Column>}
                {valueConfiguration === CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE && selectedMac &&
                    <Column>
                        <PaginatedTable
                            data={searchDataForTestConfigTable()}
                            renderRow={renderTestConfigTableRow}
                            renderHeader={renderTestConfigTableHeader}
                            renderSearchRow={renderSearchRow}
                            sortColumn={autoLoaderTestPackageSortColumn}
                            sortDirection={autoLoaderTestPackageSortOrder}
                            onSort={({sortColumn, sortDirection}) => {
                                setAutoLoaderTestPackageSortColumn(sortColumn);
                                setAutoLoaderTestPackageSortOrder(sortDirection);
                            }}
                        />
                        <Row width="100%" widths={["100", "100", "fill", "100"]}>
                            <Button onClick={onClickAddSingle}
                                    type="primary"
                                    size="small">
                                <Icon tokens={plusCircleTokens}/>
                                {getLocalizedMessage({intl, stringId: "autoloadertestconfig.addupdate"})}

                            </Button>
                            <Button onClick={onClickUploadCSV}
                                    type="primary"
                                    size="small">
                                <Icon tokens={uploadTokens}/>
                                {getLocalizedMessage({intl, stringId: "autoloadertestconfig.uploadCSV"})}

                            </Button>
                            <Box></Box>
                            <Button onClick={onClickDeleteConfiguration}
                                    size="small" type="tertiary">
                                <Icon tokens={trashTokens}/>
                                {getLocalizedMessage({intl, stringId: "autoloader.testconfig.delete"})}

                            </Button>
                        </Row>
                        <UploadFileModal mac={selectedMac}
                                         open={openCSVModal} setOpen={setOpenCSVModal}
                                         parser={AutoLoaderTestConfigCSVParser}
                                         updateConfig={updateTestConfigDraftData}/>
                        <AddAutoLoaderTestPackageModal mac={selectedMac}
                                                       open={openAddModal} setOpen={setOpenAddModal}/>
                        <DeleteAutoLoaderTestPackageModal mac={selectedMac}
                                                          open={openDeleteModal} setOpen={setOpenDeleteModal}/>
                        <div ref={tableEndRef}/>
                    </Column>}
            </Column>
        );
    }
}

export default injectIntl(AutoLoaderDeviceConfiguration);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/AutoLoaderDeviceConfiguration.js